import type { Resource as ResourceModel } from '@/adapters/catalogv1.g';

export function extractResource(model: ResourceModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.resource_ref ?? '',
    name: model.name ?? '',
    resourceType: model.resource_type ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogResource = ReturnType<typeof extractResource>;
